import React from "react";
import { PendingLoan } from "../../../containers";

const ManageLoan = (props) => {
  return <PendingLoan {...props} />;
};

export default ManageLoan;
